import { Component, OnInit } from '@angular/core';
import { MessagingService } from './messagingservice';
import { NotificationToastService } from './notification/notification-toast.service';
import { CompanyService } from './hrms/shared/company.service';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase-admin';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  providers: [NotificationToastService]
})
export class AppComponent implements OnInit{
  message: any;
  constructor(private msgService: MessagingService, private nf: NotificationToastService, private companyService:CompanyService, private auth:AngularFireAuth) {
    /* firebase.auth().getUserByEmail("superadmin@gmail.com")
  .then((userRecord) =>{
    // See the tables above for the contents of userRecord
    console.log("Successfully fetched user data:", userRecord.toJSON());
  })
  .catch(function(error) {
    console.log("Error fetching user data:", error);
  }); */
  //this.auth.auth.
  }
  ngOnInit()
  {
    this.msgService.getPermission();
    this.msgService.receiveMessage();
    this.message = this.msgService.currentMessage;
    //console.log("message", this.message);
    this.nf.addToast({title:'Registration Success', msg:'New Supervisor has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
    //console.log("companyService",this.companyService.department);
    var randomstring = Math.random().toString(36).slice(-8);
    //console.log("randomstring",randomstring);
  }
  
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/app.component.ts